export default {
    isAuthenticated: (state) => {
        return state.auth.isAuthenticated()
    }
}



// WEBPACK FOOTER //
// ./src/store/getters.js